export const convertFileTypeToIcon = (fileType: string) => {
  fileType = fileType.toLowerCase();
  if (fileType.startsWith("image/")) {
    return "material-icon-theme:image";
  }
  switch (fileType) {
    case "application/pdf":
    case "pdf":
      return "vscode-icons:file-type-pdf2";

    case "png":
    case "image/png":
      return "vscode-icons:file-type-image";

    case "docx":
    case "application/msword":
    case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      return "vscode-icons:file-type-word";

    case "xlsx":
    case "application/vnd.ms-excel":
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      return "vscode-icons:file-type-excel";

    case "pptx":
    case "application/vnd.ms-powerpoint":
    case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
      return "vscode-icons:file-type-powerpoint";

    // Google Workspace file types (branded SVG icons for main types, simple-icons fallback for rare types)
    case "application/vnd.google-apps.document":
      return "/icons/google/docs.svg";

    case "application/vnd.google-apps.spreadsheet":
      return "/icons/google/sheets.svg";

    case "application/vnd.google-apps.presentation":
      return "/icons/google/slides.svg";

    case "application/vnd.google-apps.folder":
      return "/icons/google/drive.svg";

    case "application/vnd.google-apps.form":
      return "/icons/google/forms.svg";

    case "application/vnd.google-apps.drawing":
      return "simple-icons:googledrive";

    case "application/vnd.google-apps.map":
      return "simple-icons:googlemaps";

    case "application/vnd.google-apps.script":
      return "simple-icons:googleappsscript";

    case "application/vnd.google-apps.site":
    case "application/vnd.google-apps.jam":
      return "simple-icons:google";

    // Text formats
    case "text/markdown":
    case "text/x-markdown":
      return "vscode-icons:file-type-markdown";

    case "text/plain":
      return "vscode-icons:file-type-text";

    case "text/csv":
      return "vscode-icons:file-type-csv";

    case "application/json":
      return "vscode-icons:file-type-json";

    default:
      return "vscode-icons:default-file";
  }
};
